import {
    CREATEROO,
    DELETEROO,
    LISTOFROO,
    EDITROO,
    VIEWROO,
    GET_QUOTATION_LIST,
    GET_WORK_ORDER_LIST,
    RO_NUMBER_LIST,
    PO_NUMBER_LIST,
    RECIEVED_PO_LIST
  } from "./ApiRoutes";
  import { authData } from "./services";
  
  export const createROO = async (data: object) => {
    const response = await authData.post(CREATEROO, data);
    return response?.data;
  };
  export const updateROO  = async (id: number, data: object) => {
    const response = await authData.put(`${EDITROO}/${id}`, data);
    return response?.data;
  };

  export const listOfROO  = async (data: object) => {
    const response = await authData.post(LISTOFROO, data);
    return response?.data;
  };
  export const viewROO  = async (id: number) => {
    const response = await authData.get(`${VIEWROO}/${id}`);
    return response?.data;
  };

  export const deleteROO  = async (id: number) => {
    const response = await authData.delete(`${DELETEROO}${id}`);
    return response?.data;
  };

  export const getQuotationList = async (data: object)=>{
    const response = await authData.post(`${GET_QUOTATION_LIST}`,data);
    return response?.data;
  }

  export const getWorkOrderList = async ()=>{
    const response = await authData.get(`${GET_WORK_ORDER_LIST}`);
    return response?.data;
  }

  export const getRONumberList = async ()=>{
    const response = await authData.get(`${RO_NUMBER_LIST}`);
    return response?.data;
  }
  
  export const getPONumberList = async ()=>{
    const response = await authData.get(`${PO_NUMBER_LIST}`);
    return response?.data;
  }

  export const getFullyPONumberList = async ()=>{
    const response = await authData.get(`${RECIEVED_PO_LIST}`);
    return response?.data;
  }
  